// Event statuses (migration 0039), types of event and their labels.
export type EventStage = 'scheduled' | 'active' | 'awaiting_results' | 'finalizing' | 'completed' | 'cancelled' | 'postponed';

export const STAGES: { key: EventStage; label: string; help: string }[] = [
  { key: 'scheduled', label: 'Scheduled', help: 'Booked; the first testing day has not come yet.' },
  { key: 'active', label: 'Active', help: 'On the testing days.' },
  { key: 'awaiting_results', label: 'Awaiting results', help: 'Testing is over; a service is still ordered (labs, drug screens, EKG reads).' },
  { key: 'finalizing', label: 'Finalizing', help: 'Results are in; visits are waiting to be signed or released, or for staff to mark the event completed.' },
  { key: 'completed', label: 'Completed', help: 'Marked completed by staff: reports sent to the department.' },
  { key: 'postponed', label: 'Postponed', help: 'Waiting for a new date; setting one puts the event back on schedule.' },
  { key: 'cancelled', label: 'Cancelled', help: 'Not happening (hidden from the list unless you show cancelled events).' },
];
export const STAGE_LABEL = Object.fromEntries(STAGES.map((s) => [s.key, s.label])) as Record<EventStage, string>;

/** Types of event (NGF can ask for more). */
export const EVENT_TYPES = ['Onsite physicals', 'COHSG screening', 'Office day (NGF)', 'Labs / blood draw', 'Make-up day', 'Other'];
